import camelCase from 'lodash/camelCase';

export const NODE_TYPES = {
  TEXT: 3,
};

export const TAG_NAMES = {
  BR: 'BR',
  DIV: 'DIV',
};

export const NBSP = String.fromCharCode(160);

export const isNodeTruncated = node => {
  const clone = node.cloneNode(true);
  clone.style.display = 'inline';
  clone.style.width = 'auto';
  clone.style.visibility = 'hidden';
  clone.style.position = 'absolute';
  document.body.appendChild(clone);
  const desiredWidth = clone.getBoundingClientRect().width;
  const actualWidth = node.getBoundingClientRect().width;
  const isTruncated = desiredWidth > actualWidth;
  document.body.removeChild(clone);
  return isTruncated;
};

const parseDocumentWithDOMParser = html =>
  new DOMParser().parseFromString(html, 'text/html');

const parseDocumentWithInnerHTML = html => {
  const doc = document.implementation.createHTMLDocument('');
  doc.body.innerHTML = html;
  return doc;
};

const isDOMParserSupported = (() => {
  try {
    return !!parseDocumentWithDOMParser('');
  } catch {
    return false;
  }
})();

export const parseDocument = isDOMParserSupported
  ? parseDocumentWithDOMParser
  : parseDocumentWithInnerHTML;

export const toReactStyle = style =>
  Array.from(style).reduce((memo, key) => {
    memo[camelCase(key)] = style.getPropertyValue(key);
    return memo;
  }, {});

export const selectedOptionText = selectEl => {
  const option = selectEl.options[selectEl.selectedIndex];
  return option ? option.innerText : '';
};
